import React, { memo } from 'react';
import { Col, Row, Tag, Typography } from 'components';
import { convertEnumsToReadableStrings } from 'utils/helpers';
import styles from './styles.module.scss';
import { CommercialOfferStatus } from '../utils';

interface OfferInfoProps {
  offerNumber: string;
  uuid: string | number;
  status: string;
  reason?: string;
  negotiatePhase?: string;
  negotiateInformation?: string;
  additionalInformation?: string;
  getStatusTagColor: () => string;
  getStatusDisplayText: () => string;
}

const { Text } = Typography;

export const OfferInfo: React.FC<OfferInfoProps> = memo(
  ({ reason, additionalInformation, getStatusTagColor, getStatusDisplayText, negotiateInformation, status, uuid }) => {
    return (
      <Row gutter={[8, 12]}>
        <Col span={24}>
          <Text ellipsis={{ tooltip: true }} className={styles.offerNumber}>
            Offer Number: {uuid}
          </Text>
        </Col>
        <Col span={24}>
          <Tag color={getStatusTagColor()}>{getStatusDisplayText()}</Tag>
        </Col>
        {reason && (
          <Col span={24} className={styles.description}>
            <Text ellipsis={{ tooltip: true }} style={{ fontSize: 16 }}>
              {convertEnumsToReadableStrings(reason)}
            </Text>{' '}
            <br />
            {additionalInformation && <Text ellipsis={{ tooltip: true }}>{additionalInformation}</Text>}
          </Col>
        )}
        {status === CommercialOfferStatus.NEGOTIATION && negotiateInformation ? (
          <Text style={{ maxWidth: '90%' }} ellipsis={{ tooltip: true }}>
            {negotiateInformation}
          </Text>
        ) : (
          ''
        )}
      </Row>
    );
  }
);
